

import angular from 'angular';
var module = angular.module('pi.canvas',[]);

module.service('managerCanvas', managerCanvasService);
import managerCanvasService from './managerCanvasService';

export default module;
